/** @format */

export const DATE_FORMATS = {
  "DD.MM.YYYY": "DD.MM.YYYY",
  "DD-MM-YYYY": "DD-MM-YYYY",
  "DD.MM.YYYY hh:MM": "DD.MM.YYYY hh:MM",
  "DD MMM YY hh:MM": "DD MMM YY hh:MM",
  "MMM DD YYYY hh:MM": "MMM DD YYYY hh:MM",
  "YYYY-MM-DD": "YYYY-MM-DD",
};

export const userTypes = {
  admin: "ADMIN",
  user: "USER",
};

export const userRoles = {
  admin: "admin",
  user: "user",
};

export const storeTypes = {
  cocoBuild: "COCO BUILT",
  cocoAcquired: "COCO ACQUIRED",
};
export const userStates = {
  isProcessing: "Checking",
};
export const allStores = Object.values(storeTypes);
export const leadStatusMap = {
  lead: "Lead",
  cfud1: "CF - UD 1",
  cfud2: "CF - UD 2",
  cfud3: "CF - UD 3",
  cfudFinal: "CF - UD Final",
  cfUploaded: "CF uploaded",
  cfApproved: "CF Approved",
  termSheetSigned: "Term Sheet Signed",
  underConstruction: "Under Construction",
  registered: "Registered",
  handoverToOps: "Handover to Ops",
  opened: "Opened",
  dropped: "Dropped",
  cfApproved: "CF Approved",
};

export const leadStatuses = Object.values(leadStatusMap);

export const stageGatesMap = {
  siteIdentification: "Site identification post discussion with Ops",
  siteFeasabilty: "Site Feasibility",
  cfApproval: "CF Approval",
  loiSigning: "LOI Signing",
  securityDepositPaymentTranche: "Security Deposit Payement Tranche 1",
  layoutDesign: "Layout Design",
  possessionDate: "Possession Date",
  titleDeligence: "Title Diligence",
  fssaiLicenseReceipt: "FSSAI License receipt",
  handOverToOperations: "Handover to operations",
  storeOpened: "Store Opened",
};

export const stageGatesDatesInOrder = [
  "Site identification post discussion with Ops Date",
  "Site Feasibility Date",
  "Submission of final Layout & Capex budget Date",
  "CF discussion with BD & RM Date",
  "SRP sent to Business Finance Date",
  "CF discussion with BD, RM, NBDH & NOH Date",
  "CF discussion with COO Date",
  "SRP sent to COO Date",
  "SRP approved by COO Date",
  "CF discussion with CFO Date",
  "CF creation date",
  "Approver 1 date",
  "Approver 2 date",
  "Approver 3 date",
  "Approver 4 date",
  "Approver 5 date",
  "Approver 6 date",
  "CF Approval Date",
  "LOI Signing Date",
  "Sec Deposit Payment Tranche1 Date",
  "Layout Design Date",
  "Possession Date",
  "Title Diligence Date",
  "FSSAI License receipt Date",
  "Registration Date",
  "Registration Status",
  "Handover to operations Date",
  "Store Opened Date",
];
